
export class InfoPendents { 
  Pendents: number;

  constructor() {
    this.Pendents = 0;
  }
}
